import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-plus\"><path d=\"M8.004 16c.403 0 .745-.32.745-.706V8.732h6.514A.746.746 0 0 0 16 8.004a.741.741 0 0 0-.737-.729H8.749V.706C8.749.32 8.407 0 8.004 0c-.41 0-.745.32-.745.706v6.57H.745c-.395 0-.745.326-.745.728 0 .394.35.728.745.728h6.514v6.562c0 .386.334.706.745.706Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol